import { jsonp } from 'amkit3-modules/utils/ajax'
import { HUYA_AD } from 'amkit3-modules/utils/services/urls'

export const getAdInfo = (partner, source_url, vid, channelId, cb) => {
  // setTimeout(() => cb(null, []), 100)
  cb(null, [])
}
export default {
  getAdInfo,
}
